export default "__VITE_ASSET__KDoT4GKd__"